export default __webpack_public_path__ + "static/media/LifeResources.3f62a80c6e871694a04ea90fa800cbfa.webp";